import { api } from '../api';

import { useQuery, UseQueryResult } from 'react-query';
import { GetResponseBody } from '../types/api-response';
import { ClientQueryOverview } from '../types/client-query';
import { isMock } from '../utilities/is-mock';

type UseClientQueriesConfig = {
    page?: number;
    limit?: number;
    search?: string;
    sort?: string;
    filter?: string;
};

async function getClientQueries(workpaperId: string, config: UseClientQueriesConfig): Promise<GetResponseBody<ClientQueryOverview[]>> {
    const query = isMock()
        ? `?filter=${config.filter}&search=${config.search}&sort=${config.sort}`
        : `?${config.filter}&search=${config.search}&${config.sort}`;
    const { data } = await api.get(`/workpapers/${workpaperId}/client-queries${query}`);
    return data;
}

export function useClientQueries(
    workpaperId: string,
    config: UseClientQueriesConfig
): UseQueryResult<GetResponseBody<ClientQueryOverview[]>, unknown> {
    return useQuery(['workpapers', workpaperId, 'client-queries', ...Object.values(config)], () => getClientQueries(workpaperId, config), {
        keepPreviousData: true,
        retry: false,
        enabled: config.filter !== undefined && config.sort !== undefined,
    });
}
